import Trustpilot from '~components/Trustpilot/Trustpilot';
import BBBAccredited from '~images/inline/BBB.accredited.inline.svg';

export default function TrustPilotBlock({ type }: { type: 'basic' | 'advanced' }) {
    switch (type) {
        case 'basic':
            return (
                <Trustpilot size="newthin" className="hidden md:block py-4 bg-gray-lighter mb-6" />
            );
        default:
            return (
                <>
                    <div className="pb-8 flex flex-col md:flex-row items-center justify-center">
                        <Trustpilot size="newthin" className="max-w-[480px] flex-1" />
                        <div className="pt-8 md:pt-0 flex justify-center min-h-[72px] md:min-h-10">
                            <div className="pr-2">
                                <div
                                    className="norton-placeholder w-20"
                                    id="DigiCertClickID_onwANETs_16"
                                />
                            </div>
                            <div className="pl-2">
                                <a
                                    href="https://www.bbb.org/us/ca/santa-clara/profile/insurance-companies/ehealthinsurance-services-1216-359700#bbbseal"
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label="BBB Accredited Business, BBB rating A plus"
                                >
                                    <BBBAccredited width={85} height={30} alt="" loading="lazy" />
                                </a>
                            </div>
                        </div>
                    </div>
                </>
            );
    }
    return null;
}
